import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Loading } from 'tdesign-react';
import CountUp from 'react-countup';
import { fetchOverview } from '@/slices/kopZookeeperSlice';
import ShadowCard from '@/components/ShadowCard';
import { getChartsData } from '@/services/kopZookeeperService';
import BoardPanel from '@/components/Cluster/BoardPanel';
import SummaryBlock from '@/components/Cluster/SummaryBlock';
import HealthGaugeBlock from '../../components/HealthGaugeBlock';

function Dashboard({ fetchOverview, overview, loading }) {
  const [searchParams] = useSearchParams();
  const clusterName = searchParams.get('name');
  useEffect(() => {
    if (clusterName) {
      fetchOverview(clusterName);
    }
  }, [clusterName, fetchOverview]);

  if (!clusterName) return null;

  return (
    <Loading loading={loading}>
      <Root>
        <Summary>
          <HealthGaugeBlock mode='Zookeeper' />
          <SummaryBlock
            title='ZK'
            theme='blue'
            info={
              <>
                <CountUp end={overview.activeZKNodeCount} duration={0.4} />/
                <CountUp end={overview.totalZKNodeCount} duration={0.4} />
              </>
            }
            unit={overview.zkVersion}
          />
          <SummaryBlock
            title='ZNode'
            theme='green'
            info={<CountUp end={overview.zkDataNodeCount} duration={0.4} />}
            unit='个'
          />
          <SummaryBlock
            title='Watch'
            theme='yellow'
            info={<CountUp end={overview.watchCount} duration={0.4} />}
            unit='个'
          />
          <SummaryBlock theme='blue' title='Leader' info={overview.leaderIp || '-'} />
          <SummaryBlock
            title='Follower'
            theme='green'
            info={<CountUp end={overview.followerCount} duration={0.4} />}
            unit='个'
          />
          <SummaryBlock
            title='Observer'
            theme='yellow'
            info={<CountUp end={overview.observerCount} duration={0.4} />}
            unit='个'
          />
        </Summary>
        <BoardPanel
          style={{ flex: 1, width: 0, marginTop: -14 }}
          getChartsData={async (params) => await getChartsData({ clusterName, ...params })}
        />
      </Root>
    </Loading>
  );
}

export default connect(
  (state) => ({
    overview: state.kopZookeeper.overview,
    loading: state.kopZookeeper.loading,
  }),
  {
    fetchOverview,
  },
)(Dashboard);

const Root = styled.div`
  display: flex;
  align-items: flex-start;
  padding-right: 20px;
`;

const Summary = styled(ShadowCard)`
  width: 260px;
  margin-right: 16px;
`;
